module.exports = __webpack_public_path__ + "static/media/Telephone.3386a316.png";